import { Typography, styled } from "@mui/material";

export const FilterTitle = styled(Typography)(() => ({
    paddingTop: "1rem",
    paddingBottom: "0.25rem",
    fontWeight: 500
}));